<div id="elevaagendaedu">
  <main class="fullheight">
    <P>
      <img src="assets/img/failed.png">
    </P>
    <h1>Ops! Você não tem acesso as faturas</h1>
    <p>Para visualizar é necessário que você seja o responsável financeiro.</p>
  </main>
</div>
